import { useTranslation } from 'react-i18next';
import { ReactElement } from 'react';
import { DrawerPanel } from '@dmc/ui';
import { CasFormFilePicker } from '@cas/components/inputs/cas-form-file-picker/CasFormFilePicker';
import { QueryTag, TagList } from '@casops/store/api';
import { TagDescription } from '@reduxjs/toolkit/query';
import { FileUploadModel } from '@casops/store/apis/commonModels';
import ModelForm from '@casops/components/layout/model-form/ModelForm';
import useFileUploadForm from '@casops/components/layout/model-form/useFileUploadForm';

type FormModel = FileUploadModel;

const endpointUrl = 'api/assetcertificates';
const tagsToClear: TagDescription<QueryTag>[] = [{ type: QueryTag.Certificate, id: TagList }];

const initialValues: FormModel = {
  file: undefined,
};

export function CertificateImportPanel(): ReactElement {
  const { t } = useTranslation();

  const formProps = useFileUploadForm<FormModel>({
    endpointUrl,
    tagsToClear,
    defaultValues: initialValues,
    successMessage: t('CertificatesImportedSuccessfully'),
  });

  return (
    <DrawerPanel header={t('CertificateImportTitle')}>
      <ModelForm {...formProps} submitLabel={t('Import')}>
        <CasFormFilePicker
          control={formProps.control}
          name="file"
          accept=".zip"
          minHeight="200px"
        />
      </ModelForm>
    </DrawerPanel>
  );
}

export default CertificateImportPanel;
